<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.is-size-3 
              | Artículos para reasignar
              | &nbsp
              router-link.a.button.is-dark.is-rounded.is-size-6.is-medium(to="/Inventario/")
                i.fas.fa-times  
        .columns
          .column.is-12
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Artículos para reasignar
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  TableItemsReasignaciones(:items="articulosReasignar")
        .columns
          .column.is-12
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Formulario
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  FormCambioAsignacion(:usuarios="empleados" :items="articulosReasignar")
</template>

<script>
  import NavBarInventario from './layout/NavBarInventario.vue'
  import TableItemsReasignaciones from './TableItemsReasignaciones.vue'
  import FormCambioAsignacion from './FormCambioAsignacion.vue'
  import Loader from '../shared/Loader.vue'
  import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
  import { mapState } from 'vuex'
  import InventarioServices from '../../services/inventario/inventario'
  import usuariosServices from '../../services/usuarios/usuarios'

  export default {
    name: 'Reasignar',
    components: { NavBarInventario, Loader, TableItemsReasignaciones, BulmaAccordion, BulmaAccordionItem, FormCambioAsignacion },
    data() {
      return {
        isLoading: true,
        empleados: []
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerUsuarios()
      },
      obtenerUsuarios () {
        usuariosServices.getUsuarios()
          .then(res => {
            this.empleados = res.filter( r => r.categoria === '1' || r.categoria === '2' || r.categoria === '3')
            this.isLoading = false
          })
      }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['userLogin', 'articulosReasignar'])
    }
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/Reasignar.vue